<script setup>
  import ListeDemandesArchives from '@/components/ListeDemandesArchives.vue'

</script>

<template>
  <h1>Liste des demandes archivées</h1>
  <div class="demandes">
    <ListeDemandesArchives/>
  </div>
</template>

<script>


export default {

}
</script>

<style>


</style>
